import { render } from "./Main.vue?vue&type=template&id=b87eb450&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=b87eb450&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-b87eb450"

export default script